module.exports = {
  apiHost: "https://api.vantageloganreserve.sensoreal.app",
  assetsHost: "https://assets.vantageloganreserve.sensoreal.app",
  brandName: "Vantage Logan Reserve",
  header: {
    text: { en: "Your Vantage Logan Reserve Selections" },
    logo: "",
    companyLogo: "",
    color: "#fff",
  },
  langs: [{ code: "en", dir: "ltr" }],
  style: {
    primaryColor: "#2f4b5b",
    textColor: "#fff",
    font: "Interstate",
  },
  contact: {
    website: "https://vantageloganreserve.avid.com.au",
    address: "Noffke Court, Logan Reserve QLD 4133",
    phone: "1800 564 737",
    email: "vantageloganreserve@avid.com.au",
  },
  links: {
    privacy: "",
    youtube: "",
    linkedin: "",
    twitter: "",
    instagram: "https://www.instagram.com/avid_together/",
    facebook: "https://www.facebook.com/vantagebyAVID",
  },
  footerLogo:
    "https://static-mbh.sgp1.cdn.digitaloceanspaces.com/avid-edm/general/AVID_White_72dpi.png",
};
